import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

import { AtividadeOsVinculada } from '../models/atividade-os-vinculada';

@Injectable({
  providedIn: 'root',
})
export class AtividadeOsVinculadaService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getOSsVinculadas(idAtividade: number): Observable<AtividadeOsVinculada[]> {
    const url = this.environmentUrl + 'atividade/' + idAtividade + '/OsComplementar';
    return this.httpClient.get<AtividadeOsVinculada[]>(url);
  }

  getOSComplementar(osComplementar: any) {
    const url = this.environmentUrl + 'atividade/EdtOsComplementar/' + osComplementar;
    return this.httpClient.get(url);
  }

  updOSComplementar(body: any) {
    const url = this.environmentUrl + 'atividade/OsComplementar/EdtOsComplementar';
    return this.httpClient.post<any>(url, body);
  }

  getComboComplementar() {
    const url = this.environmentUrl + 'atividade/Combo/OsComplementar';
    return this.httpClient.get(url);
  }
}
